module.exports = __webpack_public_path__ + "img/image 24.b76faff2.png";